import { clsx } from 'clsx';
import * as React from 'react';
import { ArticleParagraph1, ArticleParagraph2 } from '../../../../../../typography';
import { useGetIsMobileDevice } from '../../hooks';
import * as styles from './ProgressAdornment.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const ProgressAdornmentComponent = props => {
  const isMobileDevice = useGetIsMobileDevice();
  const TypographyComponent = isMobileDevice ? ArticleParagraph2 : ArticleParagraph1;
  return /*#__PURE__*/_jsx("div", {
    className: clsx(styles['progress-adornment'], isMobileDevice && styles['mobile']),
    children: /*#__PURE__*/_jsx(TypographyComponent, {
      color: "current_color",
      children: props.progress
    })
  });
};
export const ProgressAdornment = /*#__PURE__*/React.memo(ProgressAdornmentComponent);